import { GLOBAL_API_DEV_URL } from "./const";

export function globalBaseUrl() {
  const API_URL = !!process.env.REACT_APP_UMS_URL && process.env.REACT_APP_UMS_URL !== "" ? process.env.REACT_APP_UMS_URL : GLOBAL_API_DEV_URL;
  return API_URL;
}

export const globalGetApiUrl = (path) => {
  return `${globalBaseUrl()}/${path}`;
};
